import React, { useEffect } from "react";
import useBillablePatients from "../../hooks/patients/useBillablePatients";
import styles from "./RTMDashboard.module.css";
import "../../styles/PatientsDashboard.css";
import { Table, TableHead, TableBody, TableRow, CustomTableRow, TableNoContent } from "../../components/NewTable";
import TableSkeleton from "../../Skeletons/TableSkeleton";

const tableHeaders = [
  { id: 1, title: "Clinic", value: "clinicName" },
  { id: 2, title: "Patients", value: "billablePatientCount" },
  { id: 3, title: "Status", value: "status" },
];

const BillablePatientsTable: React.FC = () => {
  const { billablePatients, getBillablePatients, billablePatientsLoading } =
    useBillablePatients();

  useEffect(() => {
    getBillablePatients();
  }, []);

  const renderStatusCell = (status: string) => (
    <span className={status === "Active" ? styles.statusActive : styles.statusInactive}>
      {status}
    </span>
  );

  if (billablePatientsLoading) {
    return (
      <div className={styles.billablePatientsTable}>
        <div className={styles.tableContainer}>
          <table className={styles.skeletonTable}>
            <thead>
              <tr>
                {tableHeaders.map((header) => (
                  <th key={header.id}>
                    <div className={styles.skeletonHeader}></div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              <TableSkeleton columns={5} rows={3} />
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.billablePatientsTable}>
      <h3>Total Billable Patients</h3>
      {billablePatients && billablePatients.length > 0 ? (
        <div className={styles.tableContainer}>
          <Table>
            <TableHead 
              data={tableHeaders}
            />
            <TableBody>
              {billablePatients?.map((clinic, index) => (
                <tr key={index}>
                  <td><CustomTableRow>{clinic.clinicName}</CustomTableRow></td>
                  <td><CustomTableRow>{clinic.billablePatientCount}</CustomTableRow></td>
                  <td>
                    <CustomTableRow>
                      {renderStatusCell(clinic.status)}
                    </CustomTableRow>
                  </td>

                </tr>
              ))}
            </TableBody>
          </Table>
        </div>
      ) : (
         <TableNoContent
            colSpan={tableHeaders.length}
            message="No billable patients data available"
           />
       
      )}
    </div>
  );
};

export default BillablePatientsTable;
